import { render, staticRenderFns } from "./CustomerPaymentForm.vue?vue&type=template&id=a38a7454"
import script from "./CustomerPaymentForm.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports